import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  AfterViewInit,
} from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ContactsFormService } from "../../../services/contactsform.service";
import { UserService } from "../../../services/user.service";
import { Methods } from "../../../shared/methods";
import swal from "sweetalert2";

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: any[][];
}

declare interface Event {
  evento: "";
  id: null;
  rep_id: null;
}

declare var $: any;

@Component({
  selector: "app-contact-table",
  templateUrl: "./contact-table.component.html",
  styleUrls: ["./contact-table.component.css"],
  providers: [ContactsFormService, UserService],
})
export class ContactTableComponent implements OnInit, AfterViewInit {
  public mtds: Methods = new Methods();
  @Input() assigned: boolean = false;
  @Input() blacklist: boolean = false;
  @Input() elements: string[][];
  @Input() options: Array<any> = [];
  @Output() newOptions: EventEmitter<any>;

  @Output() out: EventEmitter<Event>;

  public tableContactForm: DataTable;
  public pages;
  public pagePrev;
  public pageNext;
  public loading;
  public token;
  public privilegio;
  public identity;

  public test = [];
  @Input() bulk = [];
  public visibles = [1];
  @Output() changeBulk: EventEmitter<any>;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _ContactFormService: ContactsFormService,
    private _userService: UserService
  ) {
    this.out = new EventEmitter();
    this.newOptions = new EventEmitter();
    this.changeBulk = new EventEmitter();
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    // this.visibles = this.elements;
    console.log("this.elements => ", this.elements);
  }

  cleanBulk() {
    this.bulk = [];
    this.changeBulk.emit(this.bulk);
  }

  checkAll() {
    console.log("checkAll this.bulk.length => ", this.bulk.length);
    console.log("checkAll this.visibles.length => ", this.visibles.length);
    if (this.bulk.length == 0 && this.visibles.length == 0) return false;
    else return this.bulk.length === this.visibles.length;
  }

  check(id) {
    return this.bulk.includes(Number(id));
  }

  public busqueda = true;

  selectAll() {
    console.log("selectAll is fired");
    this.busqueda = false;
    if (this.bulk.length !== this.visibles.length) {
      console.log("entramos if 1");
      this.bulk = [...this.visibles];
    } else {
      console.log("entramos if 2");
      this.bulk = [];
    }
    console.log("selectAll this.bulk => ", this.bulk);
    this.changeBulk.emit(this.bulk);
  }

  selectItem(id) {
    const i = this.bulk.indexOf(Number(id));

    if (i === -1) {
      this.bulk.push(Number(id));
    } else {
      this.bulk.splice(i, 1);
    }
    this.changeBulk.emit(this.bulk);
  }

  saveEmit(accion, id, rep = null) {
    var send = {
      evento: accion,
      id: id,
      rep_id: rep,
    };
    this.out.emit(send);
  }

  ngOnInit() {
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      this.tableContactForm = {
        headerRow: [
          "ID",
          "Name",
          "Company",
          "Phone",
          "Email",
          "Location",
          "Date",
          "Description",
          "Rep",
        ],
        footerRow: [
          "ID",
          "Name",
          "Company",
          "Phone",
          "Email",
          "Location",
          "Date",
          "Description",
          "Rep",
        ],
        dataRows: this.elements,
      };
      this.loading = "hide";

      let total_pages = Math.ceil(this.elements.length / 10);

      //total paginas
      this.pages = [];
      for (let i = 0; i < total_pages; i++) {
        this.pages.push(i);
      }

      //pagina anterior
      if (page >= 2) {
        this.pagePrev = page - 1;
      } else {
        this.pagePrev = page;
      }

      //pagina siguiente
      if (page < total_pages) {
        this.pageNext = page + 1;
      } else {
        this.pageNext = page;
      }
    });
  }

  deleteContact(id) {
    swal
      .fire({
        title: "Remove Lead",
        text: "Are you sure to delete this Lead?",
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then(
        function (result) {
          if (result.value) {
            this._ContactFormService.deleteContacts(this.token, id).subscribe(
              (response) => {
                if (response.status == "success") {
                  this.saveEmit("reload", null);
                } else {
                  alert("An error has occurred.");
                }
              },
              (error) => {
                console.log(<any>error);
              }
            );
          }
        }.bind(this)
      );
  }

  nuevaBusqueda() {
    let self = this;
    this.visibles = [];
    this.bulk = [];
    this.changeBulk.emit(this.bulk);
    $("#datatables")
      .DataTable()
      .rows({ filter: "applied", page: "current" })
      .every(function () {
        self.visibles.push(Number(this.data()[1]));
      });
  }

  ngAfterViewInit() {
    console.log(this.options);
    let me = this;
    let visibility = [];
    for (let option of this.options) {
      if (!option.visibility) {
        visibility.push(option.origin);
      }
    }
    let positions = [];
    while (positions.length < this.options.length) {
      for (let option of this.options) {
        if (option.position === positions.length) {
          positions.push(option.origin);
          break;
        }
      }
    }

    let table = $("#datatables").DataTable({
      colReorder:
        positions.length !== 0
          ? {
              order: positions,
            }
          : true,
      columnDefs: [
        { orderable: false, targets: [0] },
        { targets: [6], type: "date" },
        { targets: visibility, visible: false },
      ],
      dom: "Bflrtip",
      order: [[1, "desc"]],
      buttons: [
        {
          extend: "excel",
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: "Excel",
          className: "btn btn-sm btn-outline-success",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "pdf",
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: "PDF",
          className: "btn btn-sm btn-outline-danger",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: "print",
          className: "btn btn-sm btn-outline-primary",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "colvis",
          text: '<i class="fa fa-columns" aria-hidden="true"></i>',
          className: "btn btn-sm btn-outline-info",
          titleAttr: "Column visibility",
        },
      ],
      pagingType: "full_numbers",
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      },
    });

    this.nuevaBusqueda();

    table.on("draw.dt", () => {
      //Do something
      this.nuevaBusqueda();
    });

    // table.on( 'page.dt', () => {
    //   this.nuevaBusqueda();
    // } );

    // table.on( 'search.dt', (e) => {
    //   if (this.busqueda) {
    //     console.log('cambio busqueda!');
    //     this.nuevaBusqueda();
    //   } else {
    //     this.busqueda = true;
    //   }
    // } );

    table.on("page.dt", () => {
      var info = table.page.info();
      console.log(info);
    });

    table.on("click", ".emitir", (e) => {
      let res = e.target.id.split("-");
      const item = this.tableContactForm.dataRows.find(
        (element) => element[0] == res[0]
      );
      // console.log(item);
      let tag = null;
      if (res[1] === "banear") {
        tag = item[3];
      } else if (res[1] === "assigned") {
        tag = item[8];
      }
      this.saveEmit(res[1], res[0], tag);
    });

    table.on(
      "column-reorder",
      function (e, settings, details) {
        for (let col of settings.aoColumns) {
          for (let option of this.options) {
            if (option.origin === col._ColReorder_iOrigCol) {
              option.position = col.idx;
              break;
            }
          }
        }
        this.newOptions.emit(this.options);
      }.bind(this)
    );

    table.on(
      "column-visibility.dt",
      function (e, settings, column, state) {
        for (let option of this.options) {
          if (option.position === column) {
            option.visibility = state;
            break;
          }
        }
        this.newOptions.emit(this.options);
      }.bind(this)
    );

    $(".card .material-datatables label").addClass("form-group");
  }
}
